import React, { useState } from 'react';
import { Alert, Box, IconButton, Container } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface AlertBannerProps {
  id: string;
  severity?: 'error' | 'warning' | 'info' | 'success';
  message: React.ReactNode; // Changed from string to ReactNode
  onDismiss?: (id: string) => void;
}

const AlertBanner: React.FC<AlertBannerProps> = ({ 
  id, 
  severity = 'info', 
  message,
  onDismiss 
}) => {
  // Check localStorage during initial state setup
  const [show, setShow] = useState(() => {
    const isSeen = localStorage.getItem(`alert_seen_${id}`) === 'true';
    return !isSeen;
  });
  
  const handleClose = () => {
    setShow(false);
    localStorage.setItem(`alert_seen_${id}`, 'true');
    if (onDismiss) onDismiss(id);
  };
  
  if (!show) return null;
  
  return (
    <Box sx={{ mb: 2, margin: 'auto', p: 1, backgroundColor: '#f5f5f5'}}>
      <Container maxWidth="xl" disableGutters sx={{ display: 'flex', justifyContent: 'center' }}>
        <Alert
          severity={severity}
          variant="filled"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ 
            alignItems: 'center',
            borderRadius: 1,
            boxShadow: 1,
            width: '100%',
            margin: 'auto',
          }}
        >
          {message} {/* Now accepts JSX content */}
        </Alert>
      </Container>
    </Box>
  );
};

export default AlertBanner;